import styles from "./PrintL.module.css";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";

import plus_icon from "../../../assets/images/icons/plus_inside_circle.png";

import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import sample_1 from "../../../assets/images/edit_screen/PrintL/sample_1.png";
import PrintLReusable from "./PrintL_Reusable";

import { useEffect, useState } from "react";
import PhotoSelection from "../PhotoSelection/PhotoSelection";
import save_icon from "../../../assets/images/icons/save_icon.png";

import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../Hooks/useAxios";
const PrintL = () => {
  const { product_id } = useParams();

  let defaultStateSingleProduct = {
    src: "",
    count: 0,
  };

  const [images, setImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [item, setItem] = useState({});
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  console.log("PRODUCT CODE IS: ");
  console.log(product_id);
  const [count, setCount] = useState(0);

  const [showSelectionPopup, setShowSelectionPopup] = useState(false);

  const [imagesLeft, setImagesLeft] = useState(0);
  const [currentImageSelectionIndex, setCurrentPhotoSelectionIndex] =
    useState(-1);
  const [psk, setpsk] = useState(0);

  let [editState, setEditState] = useState([]);

  const imageSelectionPopup = (index, count) => {
    setShowSelectionPopup(true);
    setImagesLeft(count);
    setCurrentPhotoSelectionIndex(index);
    setpsk(psk + 1);
  };
  const onPhotoSelectionEnd = (photo_url) => {
    setShowSelectionPopup(false);
    console.log(photo_url[0]);
    const temp = JSON.parse(JSON.stringify(editState));
    console.log("Before state");
    console.log(editState);
    console.log(currentImageSelectionIndex);
    temp[currentImageSelectionIndex].src = photo_url[0];
    temp[currentImageSelectionIndex].count = 1;
    console.log(temp);
    setEditState(temp);
  };

  const changeEditState = (index, state) => {
    const temp = JSON.parse(JSON.stringify(editState));
    temp[index] = state;
    setEditState(temp);
  };
  const isDesignComplete = () => {
    const tempStates = JSON.parse(JSON.stringify(editState));
    for (let i = 0; i < tempStates.length; i++) {
      if (
        !tempStates[i].imageHasBeenUploaded ||
        tempStates[i].uploadedImage === ""
      ) {
        alert("Please Upload All Images");
        return false;
      }
    }
    return true;
  };

  const [showModal, setShowModal] = useState(false);

  const confirmEdits = () => {
    if (!allImagesPicked()) {
      setShowModal(true);
      return false;
    }
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }

    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Posted THE EDIT DATA");
          console.log(res.data);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", { state: { title : "Lサイズ", subtitle : "(89mm x 127mm)", count : count, address : "", item : item } });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveToServer = () => {
    console.log("Send This to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(design);
          console.log(design.design_status);
          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
          } else {
            let tempState = [];
            for (let i = 0; i < res.data.quantity; i++) {
              const temp = JSON.parse(
                JSON.stringify(defaultStateSingleProduct)
              );
              tempState.push(temp);
            }
            setEditState(tempState);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const allImagesPicked = () => {
    let current = editState.reduce((total, item) => total + item.count, 0);
    if (current < count) {
      return false;
    }
    return true;
  };
  const imgPickedCount = () => {
    return editState.reduce((total, item) => total + item.count, 0);
  };
  const [saveSuccess, setSaveSuccess] = useState(false);
  const uploadImage = () => {
    imageSelectionPopup(currentImageSelectionIndex + 1, 1);
  };
  const imageCrossed = (index) => {
    let temp = JSON.parse(JSON.stringify(editState));

    let i = index;
    for (; i < count - 1; i++) {
      if (temp[i + 1].src === "") break;
      temp[i].src = temp[i + 1].src;
      temp[i].count = temp[i + 1].count;
    }
    temp[i].count = 0;
    temp[i].src = "";
    setEditState(temp);
    setCurrentPhotoSelectionIndex(currentImageSelectionIndex - 1);
  };
  const minusClicked = (index) => {
    if (editState[index]["count"] <= 1) return;
    let temp = JSON.parse(JSON.stringify(editState));
    temp[index]["count"] -= 1;
    setEditState(temp);
  };
  const plusClicked = (index) => {
    if (allImagesPicked()) return;
    let temp = JSON.parse(JSON.stringify(editState));
    temp[index]["count"] += 1;
    setEditState(temp);
  };
  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      {showSelectionPopup && (
        <PhotoSelection
          skey={psk}
          count={imagesLeft}
          done={onPhotoSelectionEnd}
        />
      )}
      {!showSelectionPopup && (
        <div className={styles.wooden_square_edit_screen_main_div}>
          {count > 0 && (
            <div onClick={saveToServer} className={styles.save_box_main}>
              <img
                src={save_icon}
                className={styles.save_icon_image}
                alt="save"
              />
            </div>
          )}
          <DesignBoxNavigationCrumb active={3} />
          <EditScreenItemHeaderDiv
            title={"写真プリント"}
            subtitle={"Lサイズ"}
            count={count}
            address={"会員様住所"}
            item={item}
          />
          <div className={styles.spacing01}></div>
          <EditScreenHeaderInfoDiv lines={["写真を選択してください。"]} />
          <div className={styles.spacing02}></div>
          <div className={styles.hr01}></div>
          <div className={styles.sample_header01}>Sample</div>
          <div className={styles.sample_images}>
            <img src={sample_1} width={400} height={284} alt="sample" />
          </div>
          <div
            onClick={(event) => {
              console.log(allImagesPicked());
              if (allImagesPicked()) return;
              // setImageArray(...imgArray, {
              //   count: 1,
              //   src: sampleArray[Math.floor(Math.random() * sampleArray.length)],
              // });
              uploadImage();
            }}
            className={styles.upload_image_placeholder}
          >
            <img
              className={styles.upload_image_gallery_icon}
              src={gallery_icon}
              alt="top_gallery"
            />

            <div className={styles.upload_image_placeholder_text}>写真選択</div>
          </div>
          <div className={styles.spacing01}></div>
          {/* <div className={styles.hr001}></div> */}
          {/* <div className={styles.spacing01}></div> */}
          <div className={styles.image_container_main}>
            {Array.isArray(editState) &&
              editState.length > 0 &&
              editState.map((item, index) => {
                if (item.src === "" || item.count === 0) return null;
                return (
                  <div className={styles.image_single_container} key={index}>
                    <div className={styles.image_main_div}>
                      <img
                        src={item.src}
                        className={styles.edit_image}
                        alt="edit img"
                      />
                      <div
                        onClick={() => {
                          console.log("Cross the image");

                          imageCrossed(index);
                          // setImageArray(imgArray.filter((item, i) => index !== i));
                        }}
                        className={styles.cross_div}
                      >
                        <ion-icon
                          className={styles.cross_icon}
                          name="close"
                        ></ion-icon>
                      </div>
                    </div>
                    {count > 1 && (
                      <div className={styles.single_count_section_main}>
                        <div
                          onClick={() => {
                            minusClicked(index);
                          }}
                          className={styles.minus_div}
                        >
                          _
                        </div>
                        <div className={styles.number_div}>{item.count}</div>
                        <div
                          onClick={() => {
                            plusClicked(index);
                          }}
                          className={styles.plus_div}
                        >
                          +
                        </div>
                        <div className={styles.number_text}>枚</div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          {count > 1 && (
            <div className={styles.images_picked_main_div}>
              現在、合計枚数は
              <div className={styles.image_picked_number}>
                {imgPickedCount()}
              </div>
              枚です。
            </div>
          )}

          {count > 0 && (
            <div className={styles.confirm_edits}>
              <div className={styles.confirm_header}>
                上記の内容でデザイン決定しますか？
              </div>
              <div className={styles.confirm_button_section}>
                <button
                  onClick={() => {
                    navigate("/design-box");;
                  }}
                  className={styles.confirm_button_no}
                >
                  編集へ戻る
                </button>
                <button
                  onClick={confirmEdits}
                  className={styles.confirm_button_yes}
                >
                  はい
                </button>
              </div>
            </div>
          )}
          {showModal && (
            <div className={styles.incomplete_modal_main}>
              <div className={styles.modal_head01}>
                <div>残り○枚お選びいただけます。</div>
                <div>枚数を変更するか、</div>
                <div>写真を追加してください。</div>
              </div>
              <div className={styles.modal_head02}>
                <img
                  onClick={() => {
                    uploadImage();
                    setShowModal(false);
                  }}
                  src={plus_icon}
                  className={styles.plus_icon_modal}
                  alt="plus"
                />
                追加写真選択
              </div>
              <div
                onClick={() => {
                  setShowModal(false);
                }}
                className={styles.modal_close}
              >
                <ion-icon
                  className={styles.modal_cross_icon}
                  name="close"
                ></ion-icon>
              </div>
            </div>
          )}
        </div>
      )}

      <Footer />
    </>
  );
};

export default PrintL;
